export default "__VITE_PUBLIC_ASSET__773d99a7__"